<template>
  <div class="control-centre">
    <MainBackButton :forceHome="true" />

    <div class="top">
      <div class="tabs is-fullwidth is-boxed">
        <ul>
          <!-- <li :class="{ 'is-active': isStats }" @click="setTab('stats')">
            <a class="tab">
              <i class="fa fa-list" />
            </a>
          </li> -->
          <li :class="{ 'is-active': isBusiness }" @click="setTab('business')">
            <a class="tab">
              <i class="fas fa-store-alt" />
            </a>
          </li>
          <li
            :class="{ 'is-active': isTransaction }"
            @click="setTab('transaction')"
          >
            <a class="tab">
              <i class="fas fa-receipt" />
            </a>
          </li>
          <!-- <li
            :class="{ 'is-active': isTransactionEdit }"
            @click="setTab('transaction-edit')"
          >
            <a class="tab">
              <i class="fas fa-user" />
            </a>
          </li> -->
          <li :class="{ 'is-active': isLogin }" @click="setTab('login')">
            <a class="tab">
              <i class="fas fa-lock" />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <section class="no-scrollbar">
      <!-- <SuperRecentTransactions v-show="isStats" :showChevron="false" /> -->
      <Businesses v-show="isBusiness" />
      <CreateTransactionForm v-show="isTransaction" />
      <!-- <EditTransactionForm v-show="isTransactionEdit" /> -->
      <!-- <CreateRoleForm v-show="isRole" /> -->
      <MagicLoginList v-if="isLogin" />
    </section>
  </div>
</template>

<script>
// import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton.vue";
import CreateTransactionForm from "@/components/CreateTransactionForm.vue";
// import EditTransactionForm from "@/components/EditTransactionForm.vue";
// import CreateRoleForm from "@/components/CreateRoleForm.vue";
import MagicLoginList from "@/components/MagicLoginList.vue";
import Businesses from "@/components/Businesses.vue";
// import SuperRecentTransactions from "@/components/SuperRecentTransactions.vue";

export default {
  name: "ControlCentre",
  components: {
    MainBackButton,
    CreateTransactionForm,
    // EditTransactionForm,
    // CreateRoleForm,
    MagicLoginList,
    Businesses,
    // SuperRecentTransactions,
  },
  data() {
    return {
      tab: "business",
    };
  },
  computed: {
    isStats() {
      return this.tab === "stats";
    },
    isBusiness() {
      return this.tab === "business";
    },
    isTransaction() {
      return this.tab === "transaction";
    },
    isTransactionEdit() {
      return this.tab === "transaction-edit";
    },
    isRole() {
      return this.tab === "role";
    },
    isLogin() {
      return this.tab === "login";
    },
  },
  activated() {
    // this.$store.dispatch("getBusinesses").catch((err) => this.apiError(err));
    this.checkQuery();
  },
  methods: {
    setTab(tab) {
      this.tab = tab;
    },
    checkQuery() {
      var query = this.$route.query;
      if (query.tab) this.setTab(query.tab);
    },
  },
};
</script>

<style scoped>
.top {
  /* background-color: #ddd; */
  width: 100vw;
  height: 100vh;
}
.tabs {
  padding: 12px;
  width: calc(100vw - 44px);
  position: absolute;
  right: 0px;
}
.tab {
  padding: 0px 8px;
  height: 34px;
  color: grey;
}
section {
  width: 100vw;
  height: calc(100vh - 58px);
  position: absolute;
  bottom: 0;
  overflow: scroll;
}
</style>
